/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2

import {
  createUseStyleTokens,
  createStyleTokensProvider
} from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule

const data = {
  base: `${"plasmic_tokens_k4MoYHGY6d3NVAoA3aDDg2"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"} ${"plasmic_tokens_jkU633o1Cz7HrJdwdxhVHk"}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);

export const StyleTokensProvider = createStyleTokensProvider(
  {
    base: `${"plasmic_tokens_override_k4MoYHGY6d3NVAoA3aDDg2"} ${data.base}`,
    varianted: data.varianted
  },
  _useGlobalVariants
);
